import { Post } from './types';

type SelectablePost = Pick<Post, 'id' | 'mediaType'>;

export const isPostSelectableForSelectionType = (
    post: SelectablePost | null | undefined,
    selectionType: string,
) => selectionType !== 'download' || post?.mediaType?.id !== 2;

export const buildSelectablePosts = (
    posts: Record<string, SelectablePost> = {},
    selectionType: string,
) =>
    Object.values(posts ?? {}).reduce<Record<string, SelectablePost>>(
        (acc, post) => {
            if (isPostSelectableForSelectionType(post, selectionType)) {
                acc[String(post.id)] = post;
            }
            return acc;
        },
        {},
    );

export const buildSelectablePostsOrder = (
    postsOrder: Array<string | number> = [],
    posts: Record<string, SelectablePost> = {},
    selectionType: string,
) =>
    postsOrder.reduce<Array<string | number>>((acc, id) => {
        const post = posts[String(id)];
        if (isPostSelectableForSelectionType(post, selectionType)) {
            acc.push(id);
        }
        return acc;
    }, []);
